module.exports = __webpack_public_path__ + "static/img/Updates version 2.3.0.2dcf94b.png";